type WarningFilledIconProps = {
  className?: string
  color?: string
}

export function WarningFilledIcon({
  className,
  color = 'currentColor'
}: WarningFilledIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
    >
      <circle cx="12" cy="12" r="10" fill={color} />
      <rect x="11" y="7" width="2" height="7" rx="1" fill="#101014" />
      <rect x="11" y="15" width="2" height="2" rx="1" fill="#101014" />
    </svg>
  )
}
